import React, { Component } from "react";
import Header from "./components/Header";
import Main from "./components/Main";
import "./styles/styleSheet.css";

const App = () => {
  return (
    <>
      <Main />
    </>
  );
};
export default App;
